import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate, getSortState } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC } from 'app/shared/util/pagination.constants';
import { overrideSortStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './product-offering.reducer';

export const ProductOffering = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [sortState, setSortState] = useState(
    overrideSortStateWithQueryParams(getSortState(pageLocation, 'id'), pageLocation.search),
  );

  const productOfferingList = useAppSelector(state => state.productOffering.entities);
  const loading = useAppSelector(state => state.productOffering.loading);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        sort: `${sortState.sort},${sortState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?sort=${sortState.sort},${sortState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [sortState.order, sortState.sort]);

  const sort = p => () => {
    setSortState({
      ...sortState,
      order: sortState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = sortState.sort;
    const order = sortState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="product-offering-heading" data-cy="ProductOfferingHeading">
        <Translate contentKey="crawlerBackendApp.productOffering.home.title">Product Offerings</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="crawlerBackendApp.productOffering.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/product-offering/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="crawlerBackendApp.productOffering.home.createLabel">
              Create new Product Offering
            </Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {productOfferingList && productOfferingList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="crawlerBackendApp.productOffering.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('contractType')}>
                  <Translate contentKey="crawlerBackendApp.productOffering.contractType">Contract Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('contractType')} />
                </th>
                <th className="hand" onClick={sort('variant')}>
                  <Translate contentKey="crawlerBackendApp.productOffering.variant">Variant</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('variant')} />
                </th>
                <th className="hand" onClick={sort('commercialBusiness')}>
                  <Translate contentKey="crawlerBackendApp.productOffering.commercialBusiness">
                    Commercial Business
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('commercialBusiness')} />
                </th>
                <th>
                  <Translate contentKey="crawlerBackendApp.productOffering.productSpecification">
                    Product Specification
                  </Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="crawlerBackendApp.productOffering.supplier">Supplier</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {productOfferingList.map((productOffering, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/product-offering/${productOffering.id}`} color="link" size="sm">
                      {productOffering.id}
                    </Button>
                  </td>
                  <td>
                    <Translate contentKey={`crawlerBackendApp.ContractType.${productOffering.contractType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`crawlerBackendApp.Variant.${productOffering.variant}`} />
                  </td>
                  <td>
                    <Translate
                      contentKey={`crawlerBackendApp.CommercialBusiness.${productOffering.commercialBusiness}`}
                    />
                  </td>
                  <td>
                    {productOffering.productSpecification ? (
                      <Link to={`/product-specification/${productOffering.productSpecification.id}`}>
                        {productOffering.productSpecification.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {productOffering.supplier ? (
                      <Link to={`/supplier/${productOffering.supplier.id}`}>{productOffering.supplier.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/product-offering/${productOffering.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/product-offering/${productOffering.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() => (window.location.href = `/product-offering/${productOffering.id}/delete`)}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="crawlerBackendApp.productOffering.home.notFound">
                No Product Offerings found
              </Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ProductOffering;
